module.exports = global["Library"] = require("-!/var/www/personal/node_modules/ts-loader/index.js!/var/www/personal/node_modules/ts-loader/index.js!./app.ts");